import React from 'react';
import { Link } from 'react-router-dom';

const Button = ({label}) => {
    return(
        <Link to="/" className="inline-block text-sm px-48 py-12 border-1 border-gray-500 transition-all duration-500 ease-in-out hover:bg-gray-500 hover:text-white cursor-pointer">
            {label}
        </Link>
    )
}
export default Button;